module.exports = __webpack_public_path__ + "static/fonts/Pe-icon-7-stroke.745e406.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/pe-icon-7-stroke/fonts/Pe-icon-7-stroke.eot?-2irksn
// module id = XAUd
// module chunks = 1